/* eslint-disable no-use-before-define */
import React from 'react'
import {getState, getConfig} from '../../twd/twd'

const state = getState('municipals.market-news', {
    tab: 'CUSTOM',

    customSearchType: 'cusip',
    customKeyword: '',
    customCusip: [],
    customPurpose: [],
    customState:'',
    customStateTs: 0,
    customCounty:'',
    customCity:'',
    customDate: 'this_month',

    holdingCompany: [],
    holdings: [],
    holdingDate: 'this_month',
})

const useContext = ({modal=false}={}) => {
    const [isModal] = React.useState(modal)

    const [tab, setTab_] = React.useState(state.value.tab || 'CUSTOM')
    const setTab = React.useCallback((a) => { state.set({tab:a}); setTab_(a) }, [])

    // custom-tab
    const [customSearchType, setCustomSearchType_] = React.useState(state.value.customSearchType || 'cusip')
    const setCustomSearchType = React.useCallback((a) => { state.set({customSearchType:a}); setCustomSearchType_(a) }, [])

    const [customKeyword, setCustomKeyword_] = React.useState(state.value.customKeyword || '')
    const setCustomKeyword= React.useCallback((a) => { state.set({customKeyword:a}); setCustomKeyword_(a) }, [])

    const [customCusip, setCustomCusip_] = React.useState(state.value.customCusip || '')
    const setCustomCusip = React.useCallback((a) => { state.set({customCusip:a}); setCustomCusip_(a) }, [])

    const [customPurpose, setCustomPurpose_] = React.useState(state.value.customPurpose || [])
    const setCustomPurpose = React.useCallback((a) => { state.set({customPurpose:a}); setCustomPurpose_(a) }, [])

    const defaultState = getConfig('account_states.0.stateOfResidence','')
    const [customState, setCustomState_] = React.useState(state.value.customStateTs ? state.value.customState : defaultState)
    const setCustomState = React.useCallback((a) => { state.set({customState:a, customStateTs:Date.now()}); setCustomState_(a) }, [])

    const [customCounty, setCustomCounty_] = React.useState(state.value.customCounty || '')
    const setCustomCounty = React.useCallback((a) => { state.set({customCounty:a}); setCustomCounty_(a) }, [])

    const [customCity, setCustomCity_] = React.useState(state.value.customCity || '')
    const setCustomCity = React.useCallback((a) => { state.set({customCity:a}); setCustomCity_(a) }, [])

    const [customDate, setCustomDate_] = React.useState(state.value.customDate || 'today')
    const setCustomDate = React.useCallback((a) => { state.set({customDate:a}); setCustomDate_(a) }, [])

    // holding-tab
    const [holdings, setHoldings_] = React.useState(state.value.holdings || [])
    const setHoldings = React.useCallback((a) => { state.set({holdings:a}); setHoldings_(a) }, [])

    const [holdingDate, setHoldingDate_] = React.useState(state.value.holdingDate || 'today')
    const setHoldingDate = React.useCallback((a) => { state.set({holdingDate:a}); setHoldingDate_(a) }, [])

    return {
        isModal,
        tab, setTab,

        customSearchType, setCustomSearchType,
        customKeyword, setCustomKeyword,
        customCusip, setCustomCusip,
        customPurpose, setCustomPurpose,
        customState, setCustomState,
        customCounty, setCustomCounty,
        customCity, setCustomCity,
        customDate, setCustomDate,

        holdings, setHoldings,
        holdingDate, setHoldingDate,
    }
}

export const Context = React.createContext()
export const ContextProvider = ({modal, children}) => {
    const ctx = useContext({modal})
    return <Context.Provider value={ctx}>{children}</Context.Provider>
}
export default () => React.useContext(Context)



// WEBPACK FOOTER //
// ./src/municipals/market-news/use-market-news.js